import { INodeMapping, IVersionMappingUpdate } from '../tree/TreeActions'
import { INode } from 'shared/types/tree'
import * as React from 'react'
import { allMappingUpdates, IMappingUpdate, NodeIdMap } from './utility'
import { Box, Button, TextareaAutosize } from '@mui/material'
import { doInBatches } from 'shared/utils'
import { ConfirmCommitButton } from 'shared/ui'

export function AutoMapping({
  missingMapping,
  mismatchedPaths,
  sourceIdMapping,
  destinationMapping,
  destination,
  source,
  onUpdate,
  updateMappingFunc,
}: {
  missingMapping: INodeMapping[]
  mismatchedPaths: INodeMapping[]
  sourceIdMapping: NodeIdMap
  destinationMapping: NodeIdMap
  destination: INode
  source: INode
  onUpdate: () => void
  updateMappingFunc: (
    updateInfo: IVersionMappingUpdate,
    skipUpdate?: boolean,
  ) => Promise<void>
}) {
  const [mappingUpdate, setMappingUpdate] = React.useState<IMappingUpdate[]>([])
  const [current, setCurrent] = React.useState<IMappingUpdate>()
  const [nextSet, setNextSet] = React.useState<IMappingUpdate[]>([])

  React.useEffect(() => {
    setNextSet(mappingUpdate.slice(0, 100))
  }, [mappingUpdate])

  React.useEffect(() => {
    if (
      !missingMapping ||
      !sourceIdMapping ||
      !destinationMapping ||
      !destination
    ) {
      return
    }

    setMappingUpdate(
      allMappingUpdates(
        missingMapping,
        mismatchedPaths,
        sourceIdMapping,
        destinationMapping,
        destination,
        source,
      ),
    )
  }, [
    missingMapping,
    mismatchedPaths,
    sourceIdMapping,
    destinationMapping,
    destination,
    source,
  ])

  function doUpdate(info: IMappingUpdate) {
    setCurrent(info)
    return updateMappingFunc(
      {
        id: info.mapping.id,
        to_node_id: info.toNode.id,
        deleted: false,
      },
      true,
    )
  }
  function doIt() {
    if (!mappingUpdate) return
    return doInBatches(nextSet, doUpdate)
      .then(() => setCurrent(undefined))
      .then(onUpdate)
  }

  function doMore() {
    setNextSet(mappingUpdate.slice(0, nextSet.length + 100))
  }

  return (
    <Box>
      <Box>
        Match next <Button onClick={doMore}>{nextSet.length}</Button> of{' '}
        {mappingUpdate.length}
      </Box>
      <Box>
        <ConfirmCommitButton
          disabled={!!current || !nextSet.length}
          onClick={doIt}
        >
          <>Do It</>
        </ConfirmCommitButton>
      </Box>
      {current && <Box>{current.fromTitle}</Box>}
      <TextareaAutosize
        minRows={10}
        maxRows={30}
        disabled={true}
        style={{ width: '100%' }}
        value={mappingUpdate?.map(displayText).join('\n')}
      />
    </Box>
  )
}

function displayText(update: IMappingUpdate) {
  let oldPathPart = ''
  if (update.oldToPath) {
    oldPathPart = `\nOld Mapped Path:\n${update.oldToPath}`
  }
  if (update.oldToTitle) {
    oldPathPart += `\nOld Mapped Title:\n${update.oldToTitle}`
  }
  return `${update.fromTitle}\n${update.toNode.title}\n${update.fromPath}\n${update.toPath}${oldPathPart}\n\n`
}
